// extracted by mini-css-extract-plugin
export default {"card":"styles_card__640cX","card__title":"styles_card__title__gLrKh","card__actions":"styles_card__actions__itCsm"};